<template>
  <age-requirement>
    <div class="google-login">
      <div
        v-if="formErrors.non_field_errors !== undefined"
        class="alert alert-danger"
      >
        {{ formErrors.non_field_errors[0] }}
      </div>
      <google-login
        :params="params"
        :render-params="renderParams"
        :on-success="onSuccess"
        :on-failure="onFailure"
      />
    </div>
  </age-requirement>
</template>

<script>
import GoogleLogin from 'vue-google-login';
import AgeRequirement from './AgeRequirement.vue';

export default {
  name: 'GGGoogleLogin',
  components: {
    AgeRequirement,
    GoogleLogin,
  },
  data() {
    return {
      params: {
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      },
      renderParams: {
        width: 220,
        height: 40,
        longtitle: true,
      },

      formErrors: false,
    };
  },
  methods: {
    async onSuccess(googleUser) {
      this.submitting = true;

      window.googleUser = googleUser;
      const googleUserData = googleUser.getBasicProfile();
      const postData = {
        personalID: googleUserData.getId(),
        name: googleUserData.getName(),
        email: googleUserData.getEmail(),
        picture: googleUserData.getImageUrl(),
      };

      const responseData = await this.api({
        url: 'users/googleLogin/',
        method: 'POST',
        json: postData,
      });

      this.submitting = false;

      if (responseData.status >= 200 && responseData.status < 300) {
        this.$store.commit('userData', responseData.body);
        if (this.$route.name !== 'home') {
          this.$router.push(this.$route.query.next || { name: 'home' });
        }
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
    onFailure() {
      this.errors = true;
    },
  },
};
</script>
